import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mpro-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnChanges {
  onChange = (_: any) => {}; // No-op
  onTouched = (_: any) => {}; // No-op

  @Input() label?: string;
  @Input() disabled: boolean = false;
  @Input() public readonly: boolean = false;
  @Input() loading: boolean = false;
  @Input() dark: boolean = false;
  @Input() checked: boolean;
  @Input() indeterminate: boolean;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  @Output() checkboxChange: EventEmitter<boolean> = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.checked?.currentValue && this.disabled) {
      this.checked = false;
    }
  }

  public onClick(event: any) {
    this.input.nativeElement.click();
  }

  public onInputClick(event: any) {
    this.checked = event && event.target && event.target.checked;
    this.cdr.detectChanges();
    this.onChange(this.checked);
    this.checkboxChange.emit(this.checked);
  }

  public writeValue(checked: boolean): void {
    this.checked = checked;
    this.cdr.detectChanges();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
